<template>
  <tbody :class="[showDetail ? 'isActive' : '', 'tbody']" v-if="trip">
    <tr>
      <td @click="showDetail = !showDetail">{{trip.apiName}}</td>
      <td @click="showDetail = !showDetail">{{ trip.phone }}</td>
      <td @click="showDetail = !showDetail">{{ trip.smsSize }}</td>
      <td @click="showDetail = !showDetail">{{ trip.at | moment("HH:mm DD MMM") }}</td>
      <td @click="showDetail = !showDetail">
        <v-icon v-if="!trip.isFailed" color="success">mdi-check</v-icon>
        <v-icon v-if="trip.isFailed" color="error">mdi-close</v-icon>
      </td>
      <td @click="showDetail = !showDetail">
        <v-icon>mdi-folder</v-icon>
      </td>
      <!-- <td @click="showDetail = !showDetail">
        <v-icon v-if="trip.isRetryEnable">mdi-airplane-takeoff</v-icon>
      </td>-->
    </tr>
    <tr v-if="showDetail" style="background-color:#E0F2F1">
      <td colspan="12">
        <table style="width:100%">
          <tr>
            <td colspan="3" style="width:25%">{{ trip.queryParams }}</td>
            <td colspan="3" style="width:25%">
              <small class="text-body-2">{{ trip.payload }}</small>
            </td>
            <td colspan="3" style="width:25%">
              <small class="text-body-2">{{ trip.result }}</small>
            </td>
            <td colspan="3" style="width:25%">
              <!-- <v-btn
                text
                fab
                small
                color="blue"
                :to="'/trip/' + trip._id"
                @click.native.stop
                class="mx-2 my-2"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>-->
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </tbody>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import common from "@/store/common/module/common";
import DutyClose from "@/views/trip/DutyClose";
import { doGet, doPost } from "@/store/common/module/apis";

@Component({
  name: "SMSRow",
  props: {
    value: {
      default: null,
    },
  },
})
export default class SMSRow extends Vue {
  trip = null;
  showDetail = false;

  mounted() {
    if (this.value) this.trip = this.value;
  }

  @Watch("value")
  onValueChange(val) {
    this.trip = val;
  }

  statusColor() {
    const status = this.trip ? this.trip.status : null;
    if (status == 1) return "red lighten-3";
    if (status == 2) return "purple lighten-4";
    if (status == 3) return "light-blue lighten-4";
    if (status == 4) return "amber";
    if (status == 5) return "red";
    if (status == 6) return "green lighten-3";
    if (status == 7) return "purple lighten-4";

    return "primary";
  }
}
</script>


<style scoped>
.tbody {
  height: 30px;
}
.tbody tr td {
  padding: 0 2px !important;
  cursor: pointer;
}

.tbody tr td .v-input--checkbox {
  padding: 0;
  height: 30px;
  margin-top: 8px;
}

.isActive,
.isActive:hover {
  background-color: #b2dfdb !important;
}
</style>